export const UPDATED_APP_STATUS = "UPDATED_APP_STATUS";
export const UPDATE_APP_STATUS = "UPDATE_APP_STATUS";
export const CLOSED_FORM = "CLOSED_FORM";
export const OPENED_FORM = "OPENED_FORM";

export function updateFormState(newFormState) {
  return function(dispatch) {
    return dispatch({
      type: UPDATED_APP_STATUS,
      data: newFormState
    });
  };
}

export function closeApp() {
  return {
    type: CLOSED_FORM
  };
}

export function openForm(form) {
  return {
    type: OPENED_FORM,
    form: form
  };
}
